import { render, staticRenderFns } from "./NotificacaoHeaderComponent.vue?vue&type=template&id=05866f56&scoped=true"
import script from "./NotificacaoHeaderComponent.vue?vue&type=script&lang=js"
export * from "./NotificacaoHeaderComponent.vue?vue&type=script&lang=js"
import style0 from "./NotificacaoHeaderComponent.vue?vue&type=style&index=0&id=05866f56&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05866f56",
  null
  
)

export default component.exports